import { Model } from 'pinia-orm';
import User from './User';
import CompanyUser from './CompanyUser';
import Subscription from './Subscription';
import Job from './Job';
import Jobsite from './Jobsite';
import Invoice from "./Invoice";
import PaidSubscription from "./PaidSubscription";
import BillingDetails from "./BillingDetails";
import CompanyTenants from "./CompanyTenants";

export default class Company extends Model {

    static entity = 'companies';

    static fields() {
        return {
            id: this.uid(),
            active: this.attr(false),
            country: this.attr(''),
            subdomain: this.attr(''),
            domainalias: this.attr(''),
            domainalias_verified: this.attr(false),
            email: this.attr(''),
            name: this.attr(''),
            website: this.attr(''),
            social: this.attr({}),
            logo_url: this.attr(''),
            jobsite_url: this.attr(''),
            key: this.attr(''),
            description: this.attr({}),
            back_to_company_website: this.attr({}),
            officient_linked: this.attr(false),
            free_trial: this.attr(false),
            trial_start: this.attr(null),
            trial_end: this.attr(null),
            trial_expired: this.attr(false),
            in_trial: this.attr(false),
            in_setup: this.attr(false),
            has_license: this.attr(false),
            vdab_enabled: this.attr(false),
            vdab_status: this.attr(null),
            vdab_live: this.attr(false),
            vdab_id: this.attr(null),
            vdab_password: this.attr(null),
            vdab_has_multiple_ids: this.attr(false),
            multiposting_status: this.attr('inactive'),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            is_demo: this.attr(false),
            brockmeyer_id: this.attr(null),
            feature_ids: this.attr([]),
            early_access: this.attr(false),
            slots: this.attr(0),
            slot_limit: this.attr(0),
            locked_slots: this.attr(0),
            locked_slots_until: this.attr(null),
            special_price: this.attr(null),
            legacy_price: this.attr(null),
            license_frequency: this.attr(''),
            downgrade_to: this.attr(null),
            update_license_frequency: this.attr(null),
            price_per_month: this.attr(null),
            downgrade_price_per_month: this.attr(null),
            license_expires_at: this.attr(null),
            cancel_license: this.attr(false),
            has_expired_invoices: this.attr(false),
            data_retention_period: this.attr(null),
            auto_anonymise_applications: this.attr(false),
            influx_assist: this.attr(false),
            uses_sso: this.attr(false),
            region: this.attr(null),
            disable_invoice_alerts: this.attr(null),
            seek_status: this.attr(null),
            force_2fa: this.attr(false),

            //relations
            subscriptions: this.morphMany(Subscription, 'subable_id', 'subable_type'),
            jobs: this.hasMany(Job, 'company_id'),
            jobsite: this.hasOne(Jobsite, 'company_id'),
            users: this.belongsToMany(User, CompanyUser, 'company_id', 'user_id'),
            invoices: this.hasMany(Invoice, 'company_id'),
            paid_subscriptions: this.hasMany(PaidSubscription, 'company_id'),
            billing_details: this.hasOne(BillingDetails, 'company_id'),
            company_tenants: this.hasMany(CompanyTenants, 'company_id')
        }
    }

    get use_sso_jit() {
        return this.company_tenants.some(companyTenant => companyTenant.use_sso_jit);
    }
}
